export default __webpack_public_path__ + "static/media/leaderboard-banner-cn.0f613075.webp";